/** @jsx jsx */
import { jsx } from '@emotion/react'
import { css } from '@emotion/react/macro'

import { ExpandableData } from '../../data'
import { subtitle1Css } from '../../../../lib/styles/typography'
import { alternateGray } from '../../../../lib/styles/colors'
import { srOnlyCss } from '../../../../lib/styles/cssStyles'

export type DataFieldProps = {
  /** Value of field */
  children: React.ReactNode
  /** Optional Class Name */
  className?: string | undefined
  /** Label for field */
  label: string
  /** Use Raw Value, do not use ExpandableData */
  useRawValue?: boolean
}

const fieldContainer = css`
  position: relative;
  margin: 8px 0;
`

const labelCss = css`
  ${subtitle1Css};
  color: ${alternateGray};
  font-weight: normal;
`

const defaultProps: Pick<DataFieldProps, 'className' | 'useRawValue'> = {
  className: undefined,
  useRawValue: false
}

const DataField = ({ children, className, label, useRawValue }: DataFieldProps) => {
  let value

  if (!useRawValue && (children as string)) {
    value = <ExpandableData data={children as string} />
  } else {
    value = children
  }

  return (
    <div className={className} css={[fieldContainer]}>
      <span css={[labelCss]}>
        {label}
        <span css={srOnlyCss}>This labels the following text</span>
      </span>
      <div css={subtitle1Css}>{value}</div>
    </div>
  )
}

DataField.defaultProps = defaultProps

export default DataField
